import { render, staticRenderFns } from "./PriceTableActions.vue?vue&type=template&id=5e4100ac&scoped=true&"
import script from "./PriceTableActions.vue?vue&type=script&lang=js&"
export * from "./PriceTableActions.vue?vue&type=script&lang=js&"
import style0 from "./PriceTableActions.vue?vue&type=style&index=0&id=5e4100ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4100ac",
  null
  
)

export default component.exports